import { validationMessages } from './validationMessages.schema';

export default {
  title: 'Resetowanie hasła',
  type: 'object',
  properties: {
    email: {
      format: 'email',
      type: 'string',
      fieldRequired: true
    }
  },
  allOf: [validationMessages]
};
